/** O paciente vinculado no card: as contas da tela, sem React. */

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

/** As iniciais do nome: "Cliente Exemplo" → "CE"; uma palavra, as duas primeiras letras. */
export function iniciais(nome: string | null): string {
  const palavras = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return '?';
  if (palavras.length === 1) return palavras[0]!.slice(0, 2).toUpperCase();
  return (palavras[0]![0]! + palavras[palavras.length - 1]![0]!).toUpperCase();
}

/** A idade em anos completos no dia de hoje; `null` sem data válida. */
export function idadeEmAnos(nascimento: string | null, hoje: Date): number | null {
  const m = nascimento?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const [ano, mes, dia] = [Number(m[1]), Number(m[2]), Number(m[3])];
  let anos = hoje.getFullYear() - ano;
  if (hoje.getMonth() + 1 < mes || (hoje.getMonth() + 1 === mes && hoje.getDate() < dia)) anos -= 1;
  return anos >= 0 ? anos : null;
}

/**
 * A consulta como o bloco de data mostra: dia, mês e semana, e a hora, no
 * relógio da clínica, sem passar por fuso. `null` sem data.
 */
export function partesDaConsulta(
  dataHora: string | null,
): { dia: string; mes: string; semana: string; hora: string | null } | null {
  const m = dataHora?.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return null;
  const [ano, mes, dia] = [Number(m[1]), Number(m[2]), Number(m[3])];
  return {
    dia: String(dia),
    mes: MESES[mes - 1]!,
    semana: SEMANA[new Date(Date.UTC(ano, mes - 1, dia)).getUTCDay()]!,
    hora: m[4] ? `${m[4]}:${m[5]}` : null,
  };
}
